import apiClient from './api';
import type { BookRecord, BookRecordCreate, BookRecordUpdate, RecordStatus } from '../types';

export const bookRecordService = {
  getAllRecords: async (params?: {
    skip?: number;
    limit?: number;
    status?: RecordStatus;
    book_id?: number;
  }): Promise<BookRecord[]> => {
    const response = await apiClient.get('/api/book-records', { params });
    return response.data;
  },

  getRecord: async (id: number): Promise<BookRecord> => {
    const response = await apiClient.get(`/api/book-records/${id}`);
    return response.data;
  },

  createRecord: async (recordData: BookRecordCreate): Promise<BookRecord> => {
    const response = await apiClient.post('/api/book-records', recordData);
    return response.data;
  },

  updateRecord: async (id: number, recordData: BookRecordUpdate): Promise<BookRecord> => {
    const response = await apiClient.put(`/api/book-records/${id}`, recordData);
    return response.data;
  },

  returnBook: async (id: number, returnDate?: string, notes?: string, shelfId?: number): Promise<BookRecord> => {
    const params: any = { return_date: returnDate, notes };
    if (shelfId !== undefined) {
      params.shelf_id = shelfId;
    }
    const response = await apiClient.post(`/api/book-records/${id}/return`, null, { params });
    return response.data;
  },

  getBorrowerNames: async (): Promise<string[]> => {
    const response = await apiClient.get('/api/book-records/borrower-names');
    return response.data;
  },

  getRecordsByBookId: async (bookId: number): Promise<BookRecord[]> => {
    const response = await apiClient.get(`/api/book-records/by-book/${bookId}`);
    return response.data;
  },
};
